//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionFilter(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.43 6L19.52 3H17.39L14.48 11H16.61L17.7 8H22V6H18.43Z" fill="currentColor" /><path d="M14.7 6H2V8H13.97L14.7 6Z" fill="currentColor" /><path d="M7.39 13L6.3 16H2V18H5.57L4.48 21H6.61L9.52 13H7.39Z" fill="currentColor" /><path d="M9.2998 18H21.9998V16H10.0298L9.2998 18Z" fill="currentColor" /></svg>;
}
export default IconActionFilter;